import { el } from "@dhx/ts-common/dom";
import { locale } from "@dhx/ts-diagram";
import { PropertyEvents } from "../types";
import { Text } from "./Text";

export class Uploader extends Text {
	private _loading: boolean;

	constructor(conf, evs) {
		super(conf, evs);
		this._handlers.upload = e => this._onUpload(e);
	}
	toVDOM() {
		return el(".edit-section.color-edit", [
			el(".section-title", this._config.label),
			el(".dhx_img_uploader", [
				el("label", [
					el("input.dhx_uploader_input", {
						_refs: this._uid,
						type: "file",
						name: "file",
						id: "dhx_img_upload",
						accept: ".jpg, .jpeg, .png",
						style: { display: "none" },
						onchange: this._handlers.upload,
					}),
					el(
						".dhx_uploader_preview",
						{
							id: "dhx_img_preview",
							class: this._loading ? "loading" : "",
							style: `background-image:url("${this._config.value}")`,
							_ref: this._uid,
						},
						[el(".dhx_loading")]
					),
					el(".pop-up", this._config.hint || locale.imageUpload),
				]),
			]),
		]);
	}
	protected _getBase64(file): Promise<string> {
		return new Promise<any>((res, rej) => {
			if (!file) {
				rej();
			}
			const reader = new FileReader();
			reader.onloadend = function() {
				res(reader.result);
			};
			reader.readAsDataURL(file);
		});
	}
	protected _onUpload(e: any) {
		const image = e.target.files[0];
		this._loading = true;
		this._evs.fire(PropertyEvents.beforeFileUpload);
		this._getBase64(image)
			.then(base64 => {
				this.setValue(base64);
				this._evs.fire(PropertyEvents.afterFileUpload);
			})
			.catch(_ => true)
			.then(_ => (this._loading = false));
	}
}
